import { FormControl, Grid, Radio, RadioGroup } from "@mui/material";
import { makeStyles } from "@mui/styles";
import clsx from "clsx";
import { isEmpty } from "lodash";
import React, { memo } from "react";
import CheckboxList from "./CheckboxList";
const useStyle = makeStyles({
  fontDB: {
    fontFamily: "DB Heavent !important",
  },
  fontNormal: {
    fontWeight: "normal !important",
  },
});
const RadioComponent = (props) => {
  const classes = useStyle();
  const {
    SAfsac_SubAnswer,
    answerjson14,
    onChangeAnswer14,
    choice,
    suitJson,
    handleChange,
    handleChangeSubAnswer,
    handleChangeRemark,
    handleChangeRemark2,
  } = props;
  return (
    <Grid className="pb-4">
      <FormControl style={{ width: "100%" }}>
        <RadioGroup
          value={suitJson?.SAfsac_Answer.toString()}
          onChange={handleChange}
        >
          {choice.map((row, i) => (
            <Grid key={i} className="b-bottom pl-3 pr-3">
              <Grid className="checkbox-consent" key={i}>
                <Radio value={row?.ChoiceID.toString()} />
                <Grid
                  className={clsx(
                    classes.fontDB,
                    "text-black",
                    classes.fontNormal,
                    "font-20",
                    "product-choice-p",
                    "fullWidth"
                  )}
                >
                  {row?.Text}
                </Grid>
              </Grid>
              {row?.Answer && (
                <Grid>
                  <CheckboxList
                    SAfsac_Remark={suitJson?.SAfsac_Remark}
                    SAfsac_Remark2={suitJson?.SAfsac_Remark2}
                    SAfsac_SubAnswer={
                      isEmpty(SAfsac_SubAnswer)
                        ? []
                        : SAfsac_SubAnswer.split("_")
                    }
                    SAfsac_SAmsa_Id={suitJson?.SAfsac_SAmsa_Id}
                    answerjson14={answerjson14}
                    onChangeAnswerjson14={onChangeAnswer14}
                    SAfsac_Answer={suitJson?.SAfsac_Answer}
                    Answer={row?.Answer}
                    Answer2={row?.Answer2}
                    TextAnswer={row?.TextAnswer2}
                    SubAnswer={row?.SubAnswer}
                    handleChange={handleChangeSubAnswer}
                    handleChangeRemark={handleChangeRemark}
                    handleChangeRemark2={handleChangeRemark2}
                  />
                </Grid>
              )}
            </Grid>
          ))}
        </RadioGroup>
      </FormControl>
    </Grid>
  );
};
export default memo(RadioComponent);
